import { GenresStore } from "../stores/genresStore";
import { i18n } from "../functional/languages";

let webpSupportCached: boolean = false;
const Util = {
  async isWebpSupported(): Promise<boolean> {
    if (webpSupportCached !== null) return webpSupportCached;

    webpSupportCached = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img.width > 0);
      img.onerror = () => resolve(false);
      img.src =
        "data:image/webp;base64,UklGRiIAAABXRUJQVlA4ICQAAAAwAQCdASoEAAQAAVAfJaQAAA==";
    });

    return webpSupportCached;
  },

  getWebpOrOriginal(src: string): string {
    if (!src) return src;
    if (src.endsWith(".webp")) return src;
    //@ts-ignore
    return Util.isWebpSupported ? `${src}.webp` : src;
  },
  removeParamFromPath: (partialUrl: string, paramToRemove: string) => {
    // Prepend a dummy base URL to create a valid URL object
    const dummyBase = "http://dummy.com";
    const fullUrl = new URL(
      `${dummyBase}${partialUrl.startsWith("/") ? "" : "/"}${partialUrl}`
    );

    // Get URLSearchParams and delete the parameter
    fullUrl.searchParams.delete(paramToRemove);

    // Extract the modified pathname and search part
    let newPartialUrl = fullUrl.pathname + fullUrl.search;

    // Remove the leading slash if the original partialUrl didn't have one and no pathname was added
    if (!partialUrl.startsWith("/") && newPartialUrl.startsWith("/")) {
      newPartialUrl = newPartialUrl.substring(1);
    }

    // If only the dummy base was left, ensure an empty string is returned
    if (newPartialUrl === "/") {
      return "";
    }

    return newPartialUrl;
  },

  humanReadableLength: (seconds: any) => {
    const totalMinutes = Math.floor(seconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}min`);

    return parts.join(" ");
  },

  formatAssetMetadata: (data: any) => {
    const m = [];
    if (data.tv_rating) {
      m.push(data.tv_rating);
    }
    if (data.genres) {
      const genres = data.genres.map((genre: any) => {
        return GenresStore().getGenre(genre);
      });
      m.push(genres.slice(0, 2).join(", "));
    }
    if (data.type) {
      let typeLabel = "";

      if (i18n.global.locale === "en") {
        typeLabel = data.type === "series" ? "TV Series" : "Movie";
      } else {
        typeLabel = data.type === "series" ? "Serie de TV" : "Película";
      }

      m.push(typeLabel);
    }
    if (data.year !== null) {
      m.push(data.year);
    }
    if (data.duration !== null) {
      const seriesLabel =
        i18n.global.locale === "en"
          ? data.season_count > 1
            ? " Seasons"
            : " Season"
          : data.season_count > 1
          ? " Temporadas"
          : " Temporada";
      const duration =
        data.type === "series"
          ? data.season_count + seriesLabel
          : Util.humanReadableLength(data.duration);
      m.push(duration);
    }
    return m.join(" ‧ ");
  },
};

export default Util;
